import React from 'react';

const StepIndicator = ({ currentStep, totalSteps, stepTitles }) => {
  return (
    <div className="w-full mb-8">
      <div className="flex items-center justify-between mb-4">
        {Array.from({ length: totalSteps }).map((_, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isCurrent = stepNumber === currentStep;

          return (
            <div key={stepNumber} className="flex items-center flex-1">
              <div
                className={`
                  flex items-center justify-center w-10 h-10 rounded-full font-bold
                  transition duration-300
                  ${
                    isCompleted
                      ? 'bg-green-500 text-white'
                      : isCurrent
                      ? 'bg-blue-500 text-white'
                      : 'bg-gray-200 text-gray-600'
                  }
                `}
              >
                {isCompleted ? (
                  <svg
                    className="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                ) : (
                  stepNumber
                )}
              </div>

              {stepNumber < totalSteps && (
                <div
                  className={`
                    flex-1 h-1 mx-2 transition duration-300
                    ${isCompleted ? 'bg-green-500' : 'bg-gray-200'}
                  `}
                />
              )}
            </div>
          );
        })}
      </div>

      <div className="flex justify-between text-sm">
        {stepTitles.map((title, index) => (
          <div
            key={index}
            className={`
              text-center flex-1 px-2
              ${
                index + 1 === currentStep
                  ? 'text-blue-600 font-semibold'
                  : index + 1 < currentStep
                  ? 'text-green-600'
                  : 'text-gray-500'
              }
            `}
          >
            {title}
          </div>
        ))}
      </div>
    </div>
  );
};

export default StepIndicator;
